import { BottomSheet, CardButton } from '@basic';
import { UIPaths } from '@consts';
import { GoalIcon, TaskIcon } from '@icons';
import { t } from 'i18next';
import { useRouter } from 'next/router';

const BottomNavBarMoreBottomSheet = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const router = useRouter();

  const onGoalsClick = () => {
    router.push(UIPaths.goals());
    onClose();
  };

  const onTasksClick = () => {
    router.push(UIPaths.tasks());
    onClose();
  };

  return (
    <BottomSheet
      title={t('components.navBar.moreBottomSheetTitle')}
      isOpen={isOpen}
      onClose={onClose}
      desktopVersion='none'
    >
      <div className='flex flex-row flex-wrap gap-sm px-sm pb-xxl'>
        <CardButton
          text={t('components.navBar.goals')}
          icon={<GoalIcon size={28} />}
          onClick={onGoalsClick}
        />
        <CardButton
          text={t('components.navBar.tasks')}
          icon={<TaskIcon size={28} />}
          onClick={onTasksClick}
        />
      </div>
    </BottomSheet>
  );
};

export default BottomNavBarMoreBottomSheet;
